import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import React, { useRef, useMemo } from 'react';
import { StylesProvider } from '@rexlabs/styling';
import Popout from '@rexlabs/popout';
import ActionMenuButton from './button';
import ActionMenuContent from './content';
var overrides = {
  popout: {
    padding: {
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    }
  }
};
var displayName = 'ActionMenu';
/**
 * Action Menus display a list of actions or options that a user can choose.
 */

export function ActionMenu(_ref) {
  var items = _ref.items,
      minWidth = _ref.minWidth,
      maxWidth = _ref.maxWidth,
      Icon = _ref.Icon,
      _ref$Button = _ref.Button,
      Button = _ref$Button === void 0 ? ActionMenuButton : _ref$Button,
      rest = _objectWithoutProperties(_ref, ["items", "minWidth", "maxWidth", "Icon", "Button"]);

  var openedViaKeyboard = useRef();
  var Content = useMemo(function () {
    return function (props) {
      return /*#__PURE__*/React.createElement(ActionMenuContent, _extends({
        items: items,
        maxWidth: maxWidth,
        minWidth: minWidth,
        openedViaKeyboard: openedViaKeyboard
      }, props));
    };
  }, [items, maxWidth, minWidth]);
  return /*#__PURE__*/React.createElement(StylesProvider, {
    tokens: overrides
  }, /*#__PURE__*/React.createElement(Popout, _extends({}, rest, {
    Content: Content
  }), /*#__PURE__*/React.createElement(Button, {
    tabIndex: 0,
    Icon: Icon,
    onKeyDown: function onKeyDown(e) {
      var _context;

      if (_includesInstanceProperty(_context = ['Enter', ' ', 'ArrowDown', 'ArrowUp']).call(_context, e.key)) {
        openedViaKeyboard.current = e.key;
        e.preventDefault();
        e.target.click();
      }
    }
  })));
}
ActionMenu.displayName = displayName;
export default ActionMenu;